import img1 from "./1.jpeg";
import img2 from "./2.jpg";
import img3 from "./3.jpeg";
import img4 from "./4.jpg";
import img5 from "./5.jpg";
import t1 from "./t1.jpg";
import t2 from "./t2.jpg";
import t3 from "./t3.jpg";
import Client from "./client.jpg";

const flipbookImages = [img2, img3, img4, Client, img5, t1, t2, t3];

export default flipbookImages;
